import {IBizRaffle, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {ARaffle} from "@/views/editor/service/raffle/raffle";
import {IPrizes, IRaffleRule} from "@/views/editor/service/types";

export interface IRaffleMeta {
    prizes: IPrizes[];
    chance_rules: IRaffleRule[]
    props: {
        mode: 'stock' | 'must' | 'normal'
        style: 'flop' | 'eggs' | 'blindbox' | 'game'
    }
}

export default class Raffle extends ARaffle implements IBizRaffle {
    readonly opt: IRaffleMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as IRaffleMeta
    }


    resetMeta(): IBusiness {

        const opt: IRaffleMeta = {
            chance_rules: [{
                "listen_event_id": "pms.activity.wechat.customer.sign",
                "dependencies": ["activity", "activity"],
                "target": "微信顾客",
                "chance_count": 1
            }, {
                "listen_event_id": "pms.activity.business.promotion.tire_group.group.upgrade",
                "dependencies": ["promotion/tier_group", "promotion/tier_group"],
                "target": "团长",
                "chance_count": 1
            }, {
                "listen_event_id": "pms.activity.business.promotion.tire_group.group.full",
                "dependencies": ["promotion/tier_group", "promotion/tier_group"],
                "target": "团长",
                "chance_count": 1
            }, {
                "listen_event_id": "pms.activity.business.promotion.tire_group.group.full",
                "dependencies": ["promotion/tier_group", "promotion/tier_group"],
                "target": "团成员",
                "chance_count": 1
            }, {
                "listen_event_id": "pms.activity.wechat.customer.invited.sign",
                "dependencies": ["activity", "activity"],
                "target": "邀请人",
                "chance_count": 1
            }],
            prizes: [{...this.editor.material.gifts.randomGift(), percentage: 0, stock: 0}],
            props: {mode: 'must', style: 'flop'}
        }
        Object.assign(this.opt, opt)
        return this;
    }

    emptyRule(): IRaffleRule {
        return {
            listen_event_id: '',
            dependencies: [],
            target: '',
            chance_count: 1,
        }
    }

    evtTarget = (id: string): string => {
        for (const role of this.editor.userAgent.meta.notifyRoles) {
            if (role.events[id]) return role.name
        }
        return id
    }

    evtAction(id: string): string {
        for (const role of this.editor.userAgent.meta.notifyRoles) {
            if (role.events[id]) return role.events[id]
        }
        return id
    }

    ruleDesc(rule: IRaffleRule): string {
        return `${this.evtTarget(rule.listen_event_id) + this.evtAction(rule.listen_event_id)}时${rule.target}可抽${rule.chance_count}次`.replaceAll('微信顾客', '')
    }
}